import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "submitButton"]

  connect() {
    this.initializeFormTracking()
  }

  disconnect() {
    if (this.formInputs) {
      this.formInputs.forEach(input => {
        input.removeEventListener("input", this.handleFieldChangeHandler)
      })
    }
  }

  initializeFormTracking() {
    // Initially targeting form input fields only
    this.formInputs = this.formTarget.querySelectorAll("input")
    this.initialState = this.captureCurrentFormState()
    this.updateSubmitButtonState()

    // Store bound handler for cleanup
    this.handleFieldChangeHandler = () => this.handleFieldChange()

    this.formInputs.forEach(input => {
      input.addEventListener("input", this.handleFieldChangeHandler)
    })
  }

  captureCurrentFormState() {
    const state = new Map()
    this.formInputs.forEach(input => {
      state.set(input, input.value)
    })
    return state
  }

  hasFormChanged() {
    if (!this.initialState) {
      return false
    }

    for (const input of this.formInputs) {
      if (this.initialState.get(input) !== input.value) {
        return true
      }
    }
    return false
  }

  handleFieldChange() {
    this.updateSubmitButtonState()
  }

  updateSubmitButtonState() {
    const hasChanges = this.hasFormChanged()
    this.submitButtonTarget.disabled = !hasChanges
    this.submitButtonTarget.classList.toggle("button--disabled", !hasChanges)
  }
}
